import { createGlobalStyle } from 'styled-components';
import { SHOP_ID } from '../../brikl-config';
var shopFonts = '';

export default createGlobalStyle`${shopFonts}`;
